import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class PGWContractRateEventQueryCriteriaClass extends BaseCriteriaModel {
  hdr_guid?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  obj_action?: Optional<string> = Optional.empty();
  event_code?: Optional<string> = Optional.empty();

  created_after?: Optional<string> = Optional.empty();
  created_before?: Optional<string> = Optional.empty();
  updated_after?: Optional<string> = Optional.empty();
  updated_before?: Optional<string> = Optional.empty();
  created_by_subject_guid?: Optional<string> = Optional.empty();
  contract_hdr_guid?: Optional<string> = Optional.empty();
}

export class PGWContractRateEventCriteriaModelQuery {
  query = '';

  constructor(contractRateCriteriaModel: PGWContractRateEventQueryCriteriaClass) {
    console.log('pcEventCriteriaModel', contractRateCriteriaModel);

    if (!contractRateCriteriaModel) {
      return;
    }

    this.query += contractRateCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += contractRateCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += contractRateCriteriaModel.obj_action.filter(x => x !== '').map(x => '&obj_action=' + x).orElse('');
    this.query += contractRateCriteriaModel.event_code.filter(x => x !== '').map(x => '&event_code=' + x).orElse('');
    this.query += contractRateCriteriaModel.created_after.filter(x => x !== '').map(x => '&created_after=' + x).orElse('');
    this.query += contractRateCriteriaModel.created_before.filter(x => x !== null).map(x => '&created_before=' + x).orElse('');
    this.query += contractRateCriteriaModel.updated_after.filter(x => x !== '').map(x => '&updated_after=' + x).orElse('');
    this.query += contractRateCriteriaModel.updated_before.filter(x => x !== null).map(x => '&updated_before=' + x).orElse('');
    this.query += contractRateCriteriaModel.created_by_subject_guid.filter(x => x !== null).map(x => '&created_by_subject_guid=' + x).orElse('');
    this.query += contractRateCriteriaModel.contract_hdr_guid.filter(x => x !== null).map(x => '&contract_hdr_guid=' + x).orElse('');

    this.query += '&status=' + contractRateCriteriaModel.status;
    this.query += '&orderBy=' + contractRateCriteriaModel.orderBy;
    this.query += '&order=' + contractRateCriteriaModel.order;
    this.query += '&offset=' + contractRateCriteriaModel.offset + '&limit=' + contractRateCriteriaModel.limit;
  }

}
